/** Pure warm-index row matchers split from libraryAlbumIndex (#1240 size ratchet). */
import type { AlbumIndexRow } from './libraryAlbumIndexDedupe';

function normalizeAlbumLookupPath(value: unknown): string {
  return String(value ?? '')
    .trim()
    .replace(/\\/g, '/')
    .replace(/\/+$/, '')
    .toLowerCase();
}

function normalizeAlbumLookupTitle(value: unknown): string {
  return String(value ?? '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');
}

/** Match a warm-index row by library folder or sample file path. */
export function matchAlbumRowByPath(
  rows: AlbumIndexRow[],
  libraryFolderPath?: string | null,
  sampleFilePath?: string | null,
): AlbumIndexRow | null {
  const folder = normalizeAlbumLookupPath(libraryFolderPath);
  const sample = normalizeAlbumLookupPath(sampleFilePath);
  if (!folder && !sample) return null;
  for (const row of rows) {
    const rowFolder = normalizeAlbumLookupPath(row.library_folder_path);
    const rowSample = normalizeAlbumLookupPath(row.sample_file_path);
    if (folder && rowFolder && rowFolder === folder) return row;
    if (sample && rowSample && rowSample === sample) return row;
    if (folder && rowSample && rowSample.startsWith(`${folder}/`)) return row;
  }
  return null;
}

/** Match a warm-index row by album title + album artist (case-insensitive). */
export function matchAlbumRowByTitleArtist(
  rows: AlbumIndexRow[],
  title?: string | null,
  artist?: string | null,
): AlbumIndexRow | null {
  const wantTitle = normalizeAlbumLookupTitle(title);
  const wantArtist = normalizeAlbumLookupTitle(artist);
  if (!wantTitle) return null;
  for (const row of rows) {
    const rowTitle = normalizeAlbumLookupTitle(row.title ?? row.album);
    const rowArtist = normalizeAlbumLookupTitle(row.artist_name ?? row.album_artist);
    if (rowTitle !== wantTitle) continue;
    if (wantArtist && rowArtist && rowArtist !== wantArtist) continue;
    return row;
  }
  return null;
}
